<script lang="ts">
    import type {Row} from '@tanstack/svelte-table';
    import type {HierarchicalRecordRow} from 'src/features/record-grid/lib/types';
    import type {ReportTemplate} from 'typings/portaro.be.types';
    import type {RecordGridDataManager} from 'src/features/record-grid/lib/record-grid-data-manager';
    import {getProjectLogbookPairingContext} from './project-logbook-pairing-context';
    import {getInjector} from 'core/svelte-context/context';
    import {onMount} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import ReportServerService from 'src/features/report-server/services/report-server.service';
    import {FOND_INSTALLATION_LOGBOOK} from 'src/features/erp-sutor/sutor-fonds';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import Spacer from 'shared/layouts/flex/Spacer.svelte';
    import DefaultRowOptionsCell from 'src/features/record-grid/components/cells/DefaultRowOptionsCell.svelte';
    import {SUTOR_LOGBOOK_PAIRING_PAGE} from 'src/features/erp-sutor/sutor-constants';

    export let recordGridDataManager: RecordGridDataManager;
    export let row: Row<HierarchicalRecordRow>;

    const context = getProjectLogbookPairingContext();
    const reportServerService = getInjector().getByClass(ReportServerService);

    const handleOptimiseLogbookClick = () => {
        context.setOpenedLogbook(row.original);
    };

    let loadedTemplate: ReportTemplate | null = null;

    onMount(async () => {
        loadedTemplate = await context.service.getReportServerTemplateByName(SUTOR_LOGBOOK_PAIRING_PAGE.reportServerTemplateMD);
    });

    const handlePrintClick = async () => {
        await reportServerService.downloadExport(loadedTemplate, {
            recordId: row.original.id
        });
    };
</script>

<DefaultRowOptionsCell {recordGridDataManager} {row}>
    <Spacer flex="1"/>

    {#if FOND_INSTALLATION_LOGBOOK.fond === row.original.fond.id && !row.original.draft}
        <KpButton buttonSize="xs" buttonStyle="brand-orange-new" on:click={handleOptimiseLogbookClick}>
            <IconedContent icon="link-horizontal">Přivázat náklady</IconedContent>
        </KpButton>

        {#if exists(loadedTemplate)}
            <KpButton buttonSize="xs" on:click={handlePrintClick}>
                <IconedContent icon="print">Tisk</IconedContent>
            </KpButton>
        {/if}
    {/if}
</DefaultRowOptionsCell>